import brandData from "@/data/brands.json";

export interface BrandVisual {
  background: string;
  surface: string;
  ink: string;
  muted: string;
  accent: string;
  accentContrast: string;
  motif: string;
  logoTreatment: "none" | "invert";
}

export interface Brand {
  slug: string;
  name: string;
  catalogNames: string[];
  logoFilename: string;
  founded: string;
  origin: string;
  eyebrow: string;
  statement: string;
  description: string;
  story: string[];
  facets: string[];
  signatures: string[];
  visual: BrandVisual;
}

export interface BrandPageData {
  logoBaseUrl: string;
  page: {
    eyebrow: string;
    title: string;
    description: string;
  };
  brands: Brand[];
}

export const brandsData = brandData as BrandPageData;
export const brands = brandsData.brands;

export function getBrand(slug: string): Brand | undefined {
  return brands.find((brand) => brand.slug === slug);
}

export function brandLogoUrl(brand: Brand): string {
  return `${brandsData.logoBaseUrl}/${brand.logoFilename}`;
}

export function productBelongsToBrand(productBrand: string, brand: Brand): boolean {
  const normalizedProductBrand = productBrand.trim().toLocaleLowerCase();
  return brand.catalogNames.some(
    (catalogName) => catalogName.trim().toLocaleLowerCase() === normalizedProductBrand,
  );
}
